/**
 * @generated SignedSource<<2c0b5d2bdd23fd42a85bf95038e1bd46>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type VideoDetailsDeleteMutation$variables = {
  id: string;
};
export type VideoDetailsDeleteMutation$data = {
  readonly deleteEvent: {
    readonly id: string;
  };
};
export type VideoDetailsDeleteMutation = {
  response: VideoDetailsDeleteMutation$data;
  variables: VideoDetailsDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "AuthorizedEvent",
    "kind": "LinkedField",
    "name": "deleteEvent",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "VideoDetailsDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "VideoDetailsDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "17f2aa4d2276096104fcdf9e7a41b091",
    "id": null,
    "metadata": {},
    "name": "VideoDetailsDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation VideoDetailsDeleteMutation(\n  $id: ID!\n) {\n  deleteEvent(id: $id) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "63ff38a0cc58d98b05b00e6760014847";

export default node;
